import React, { ReactNode, forwardRef } from 'react';
import clsx from 'clsx';
import styles from './PopUpCore.module.scss';
import { CSSTransition } from 'react-transition-group';
import FocusLock from 'react-focus-lock';

interface PopUpProps {
  children: ReactNode;
  className?: string;
  warningText?: string;
}

const PopUpCore = forwardRef<HTMLElement, PopUpProps>(({ children, className, warningText }, ref) => {
  return (
    <CSSTransition
      in
      appear
      timeout={Number(styles.animationTimeout)}
      classNames={{
        appear: styles.popupAppear,
        appearActive: styles.popupAppearActive,
        appearDone: styles.popupAppearDone,
      }}
    >
      <div className={clsx(styles.popupCore, className)}>
        <FocusLock className={styles.focusLockContainer}>
          <section className={clsx(styles.popupMain)} ref={ref}>
            {children}
            {warningText && (
              <p className={styles.warningText}>
                <span>Warning: </span>
                {warningText}
              </p>
            )}
          </section>
        </FocusLock>
      </div>
    </CSSTransition>
  );
});

export default PopUpCore;
